import { css } from "@nodusjs/std/dom";

export const style = () =>
  css`
    :host {
      box-sizing: border-box;
      display: block;

      form {
        container-type: inline-size;
      }
    }

    :host(:state(hidden)) {
      display: none;
    }
  `;
